

























































































































































































































































































































































































































































































































































































































































































































































import { Prop, Component, Vue, Watch } from "vue-property-decorator";

import EstimateItem from "../components/EstimateItem.vue";
import EstimateHeader from "../components/EstimateHeader.vue";
import EstimateRow from "../components/EstimateRow.vue";

import Estimate from "@/usecases/orders/estimate";
import EstimateItemModel from "@/usecases/orders/estimate-item";
import VToolbar from "../../common/components/VToolbar.vue";
import EstimateService from "@/usecases/orders/estimate-service";
import MoveEvent from "../presenters/move-event";
import SelectOption from "@/common/ui/presenters/select-option";
import EstimateApi from "../../../api/orders/estimate-api";
import { client } from "@/api/request";
import EstimateStatus from "@/usecases/orders/estimate-status";
import EstimateStatusTranslater from "@/usecases/orders/estimate-status-translater";
import UnitApi from "../../../orders/api/unit-api";
import UnitOption from "../presenters/unit-option";
import PrintApi from "../../../api/orders/print-api";
import {
  ExpenseCategory,
  getExpenseCategories
} from "@/api/cost/expense-categories-api";
import {
  calculateExpenseCategory,
  ExpenseCategoryTotal
} from "@/orders/domain/models/expense-category";
import { estimateRoundedFromProfitRate } from "@/models/estimate-from-profit-rate";
import {
  EstimateTemplate,
  EstimateTemplateItem
} from "@/api/estimate-templates-api";
import UseEstimateTemplate from "@/components/UseEstimateTemplate.vue";
import TextTemplateModal from "@/views/TextTemplateModal.vue";
import ProfitRateModal from "@/components/ProfitRateModal.vue";
import ExpensesCategoryGraphReport from "@/ui/order/components/ExpensesCategoryGraphReport.vue";
import { ESTIMATE_ITEM_LEVEL, NUMBER_ROUND, TYPE_ROUND } from "@/preferences";
import EstimateTaskDefaultsForm from "@/ui/order/components/EstimateTaskDefaultsForm.vue";
import TableCellPreviewBar from "@/ui/order/components/TableCellPreviewBar.vue";
import {
  getServiceTaskDefaults,
  ServiceTaskDefault
} from "@/api/project/service-task-default-api";
import { ProjectTaskDefault } from "@/api/project-api";
import { applyDefaultEstimatePaymentMethod } from "@/helpers/apply-default-estimate-payment-method";
import moment from "moment";
import EstimateTemplateModal from "@/ui/order/components/EstimateTemplateModal.vue";
import uuid from "uuid";
import Decimal from "decimal.js";
import LoadingButton from "@/components/LoadingButton.vue";
import Status from "@/usecases/orders/estimate-status";

const printApi = new PrintApi(client);
const estimateApi = new EstimateApi(client);
const unitApi = new UnitApi(client);
const service = new EstimateService(estimateApi);

interface EstimateItemProp {
  item: EstimateItemModel;
  unitOptions: SelectOption[];
  expenseCategoryOptions: SelectOption[];
  level: number;
  isShowNoteColumn: boolean;
  styleGridColumn: string;
  estimateRowSelected: Set<string>;
  profitRateOfEstimate: number;
  isDiscountRow: boolean;
  isFirstItemInLayer: boolean;
  index: number;
  isActualResult?: boolean;
  firstLevel?: number;
  hasChild?: boolean;
  disableBtnRight?: boolean;
}

@Component({
  methods: {
    TYPE_ROUND() {
      return TYPE_ROUND;
    },
    NUMBER_ROUND() {
      return NUMBER_ROUND;
    }
  },
  computed: {
    ESTIMATE_ITEM_LEVEL() {
      return ESTIMATE_ITEM_LEVEL;
    }
  },
  components: {
    LoadingButton,
    EstimateTemplateModal,
    ExpensesCategoryGraphReport,
    ProfitRateModal,
    TextTemplateModal,
    UseEstimateTemplate,
    VToolbar,
    EstimateItem,
    EstimateRow,
    EstimateHeader,
    EstimateTaskDefaultsForm,
    TableCellPreviewBar
  }
})
export default class EditEstimatePage extends Vue {
  @Prop({ required: true }) id!: string;
  @Prop({ required: true }) projectId!: number;

  textTemplateModalOpen = false;
  calcFromProfitRateModalOpen = false;
  calcInvoiceFromProfitRateModalOpen = false;

  move(e: MoveEvent) {
    // 子がいる親を子にすることはできない
    const from = e.from.dataset.type;
    const to = e.to.dataset.type;
    const children = e.draggedContext.element.items.length;
    const grandchildren = e.draggedContext.element.items.reduce(
      (total, item) => total + item.items.length,
      0
    );
    return !(
      (from === "parents" && to === "grandchildren" && children > 0) ||
      (from === "children" && to === "grandchildren" && children > 0) ||
      (from === "parents" && to === "children" && grandchildren > 0)
    );
  }

  estimate = new Estimate();
  unitOptions: SelectOption[] = [];
  expenseCategories: ExpenseCategory[] = [];
  isShowNoteColumn: boolean = true;
  expenseCategoriesSelected: ExpenseCategoryTotal[] = [];
  baseColumn = { name: "操作", subs: [], width: "3.5rem" };
  estimateSubs = [
    { name: "大項目", width: "8vw" },
    { name: "中項目", width: "8vw" },
    { name: "小項目", width: "10vw" },
    { name: "経費カテゴリ", width: "8rem" },
    { name: "数量", width: "5rem" },
    { name: "単位", width: "5rem" },
    { name: "単価", width: "6rem" },
    { name: "見積金額", width: "6rem" },
    { name: "備考", width: "1fr" }
  ];
  estimateSubsWithoutNoteColumn = [
    { name: "大項目", width: "1fr" },
    { name: "中項目", width: "1fr" },
    { name: "小項目", width: "1.2fr" },
    { name: "経費カテゴリ", width: "8rem" },
    { name: "数量", width: "5rem" },
    { name: "単位", width: "5rem" },
    { name: "単価", width: "6rem" },
    { name: "見積金額", width: "6rem" }
  ];

  budgetSubs = [
    { name: "発注単価", width: "6rem" },
    { name: "発注金額", width: "6rem" },
    { name: "利益額", width: "6rem" },
    { name: "利益率", width: "5rem" },
    { name: "発注先", width: "7rem" }
  ];

  get headerDefault(): HeaderItem[] {
    if (this.isRouteActualResult()) {
      return [
        this.baseColumn,
        { name: "見積項目", subs: [...this.estimateSubs, ...this.budgetSubs] }
      ];
    }

    return [
      this.baseColumn,
      { name: "見積項目", subs: this.estimateSubs },
      { name: "予算項目", subs: this.budgetSubs }
    ];
  }

  get headerWithoutNoteColumn(): HeaderItem[] {
    if (this.isRouteActualResult()) {
      return [
        this.baseColumn,
        {
          name: "見積項目",
          subs: [...this.estimateSubsWithoutNoteColumn, ...this.budgetSubs]
        }
      ];
    }

    return [
      this.baseColumn,
      { name: "見積項目", subs: this.estimateSubsWithoutNoteColumn },
      { name: "予算項目", subs: this.budgetSubs }
    ];
  }

  header: HeaderItem[] = this.headerDefault;
  styleGridColumn: string = this.getWidthsString(this.header);
  // The Set includes the IDs of the estimate_row at the lowest level.
  // Saving like this is for the logic of reloading the checkbox state when dragging and dropping in the table
  estimateRowSelected: Set<string> = new Set();
  isCheckAllEstimateRow: boolean = false;
  disableDestroy: boolean = true;
  orderToEstimatedNumberRound: number = NUMBER_ROUND[2];
  orderToEstimatedTypeRound: string = TYPE_ROUND[0];
  estimatedToOrderNumberRound: number = NUMBER_ROUND[2];
  estimatedToOrderTypeRound: string = TYPE_ROUND[0];
  requiredContractDate: boolean = false;
  contractDateInit: string = "";
  currentIndex: Set<number> = new Set<number>();
  statusSaveEstimate: string = "";
  statusGoToNewPurchase: string = "";
  currentRoute: string = "";
  previewValue: string = "";
  private previewResizeObserver: ResizeObserver | null = null;

  toggleNoteColumn(isChecked: boolean) {
    this.isShowNoteColumn = isChecked;
    this.header = isChecked ? this.headerDefault : this.headerWithoutNoteColumn;
    this.styleGridColumn = this.getWidthsString(this.header);
  }

  getWidthsString(header: HeaderItem[]): string {
    const widths: string[] = [];

    header.forEach(item => {
      if (item.subs.length === 0 && item.width) {
        widths.push(item.width);
      } else {
        item.subs.forEach(sub => {
          widths.push(sub.width);
        });
      }
    });

    return widths.join(" ");
  }

  addIdsFromLowestItems(items: EstimateItemModel[]) {
    items.forEach(item => {
      if (item.items.length > 0) {
        this.addIdsFromLowestItems(item.items);
      } else {
        this.estimateRowSelected.add(item.id.toString());
      }
    });
  }

  checkAllEstimateRow(isChecked: boolean) {
    this.estimateRowSelected.clear();

    if (isChecked) {
      this.addIdsFromLowestItems(this.estimate.items);
      this.addIdsFromLowestItems(
        this.estimate.children.flatMap(child => child.items)
      );
    }

    this.reloadCheckboxOfEstimateRow();
  }

  getHeaderOfSubTable(title: string) {
    let result: HeaderItem[] = [{ name: title, subs: [] }];
    return result;
  }

  get expenseCategoryOptions() {
    return this.expenseCategories.map(category => ({
      value: category.id,
      text: category.name
    }));
  }

  handlePreview(payload: { value: string }) {
    this.previewValue = payload.value;
  }

  mounted() {
    const list = (this.$refs.treeTableList as any) as HTMLElement | undefined;
    const preview = (this.$refs.previewSticky as any) as
      | HTMLElement
      | undefined;
    if (!list || !preview) return;

    const setVar = () => {
      list.style.setProperty(
        "--preview-sticky-height",
        `${preview.offsetHeight}px`
      );
    };
    setVar();

    if (typeof (window as any).ResizeObserver === "function") {
      this.previewResizeObserver = new ResizeObserver(() => setVar());
      this.previewResizeObserver.observe(preview);
    }
  }

  beforeDestroy() {
    if (this.previewResizeObserver) {
      this.previewResizeObserver.disconnect();
      this.previewResizeObserver = null;
    }
  }

  get categoryDiscountIds(): string[] {
    return this.expenseCategoryOptions
      .filter(category => category.text === "値引き")
      .map(category => category.value);
  }

  get estimatePaymentMethodSelectOptions() {
    const optsRaw: any[] = (this.estimate as any).estimatePaymentMethods || [];
    const currentRaw: any = (this.estimate as any).paymentMethod;

    const toKey = (v: any) => String(v == null ? "" : v).trim();
    const currentKey = toKey(currentRaw);
    const existingKeys = new Set(optsRaw.map(toKey).filter(k => k !== ""));

    const merged = [...optsRaw];
    if (currentKey !== "" && !existingKeys.has(currentKey)) {
      merged.push(currentRaw);
    }

    const options = merged
      .map(v => ({ value: v, text: toKey(v) }))
      .filter(o => o.text !== "");
    return options;
  }

  printing: boolean = false;

  async createPdf(id: number, printsExcludeTax: boolean) {
    if (!this.printing) {
      this.printing = true;
      try {
        const url = await printApi.getEstimatePrint(
          id,
          this.$store.state.accessToken,
          printsExcludeTax
        );
        window.open(url, "見積書印刷");
      } catch (e) {
        alert("印刷に失敗しました。しばらく待ってから改めてお試しください。");
      } finally {
        this.printing = false;
      }
    } else {
      alert("印刷中です");
    }
  }

  get statusOptions() {
    return EstimateStatus.all().map(value => ({
      value,
      text: EstimateStatusTranslater.toJp(value)
    }));
  }

  goListPage() {
    this.$router.push({ name: "order-estimates" });
  }

  async goNewPurchasePage() {
    if (!this.validateSelection()) return;

    this.statusGoToNewPurchase = "progressing";
    // validate form
    const form = this.$refs.infoEstimateForm;
    if (form instanceof HTMLFormElement && !this.validateForm(form)) {
      this.statusGoToNewPurchase = "";
      return;
    }
    // save estimate
    try {
      await this.saveEstimate();
    } catch (error) {
      this.statusGoToNewPurchase = "";
      alert("保存に失敗しました。");
      return;
    }
    // navigate to new page
    await this.navigateToNewPurchasePage();
  }

  private validateSelection(): boolean {
    if (this.estimateRowSelected.size === 0) {
      alert("対象品目をチェックしてください。");
      return false;
    }
    return true;
  }

  private validateForm(form: HTMLFormElement): boolean {
    if (!form.checkValidity()) {
      form.reportValidity();
      return false;
    }
    return true;
  }

  private async navigateToNewPurchasePage() {
    const ids = service.getIdsSelected(this.estimate, this.estimateRowSelected);
    await this.$router.push({
      name: this.isRouteActualResult()
        ? "order-estimate-purchase-actual"
        : "order-estimate-purchase",
      params: {
        estimateId: String(this.estimate.id),
        idsRowSelected: Array.from(ids).join(",")
      }
    });
  }

  async save() {
    try {
      this.statusSaveEstimate = "progressing";
      await this.saveEstimate();
      alert("保存しました。");
    } catch (e) {
      alert("保存に失敗しました。");
    } finally {
      this.statusSaveEstimate = "";
    }
  }

  private async saveEstimate() {
    await service.save(this.estimate);
    await this.edit(Number(this.id));
    // After updating the estimate, the id of the estimate_row is newly generated
    // and needs to be mapped with the ids being checked on the screen.
    this.mappingNewEstimateRowId();
    await this.$store.dispatch("getStatusProject");
    await this.$store.dispatch(
      "setContractDateProject",
      this.estimate.dateOfContract
    );
    await this.$store.dispatch("setProjectEstimateExpenseSummary");
  }

  async addNewItems(items: number) {
    for (let i = 0; i < items; i++) {
      await service.addNewItem(this.estimate);
    }
    this.reloadCheckboxOfEstimateRow();
  }

  async addNewItemAfter(itemId: string, level: number) {
    await service.addNewItemAfter(
      this.estimate,
      itemId,
      this.isRouteActualResult(),
      level
    );
    this.reloadCheckboxOfEstimateRow();
  }

  async removeItem(itemId: string) {
    this.estimate = await service.removeItem(this.estimate, itemId);
    this.estimateRowSelected.delete(itemId.toString());
    this.reloadCheckboxOfEstimateRow();
  }

  async removeAllItems() {
    if (!confirm("全ての項目を削除します。よろしいですか？")) return;
    this.estimate = await service.removeAllItems(this.estimate);
    this.estimateRowSelected.clear();
    this.reloadCheckboxOfEstimateRow();
  }

  async destroy() {
    if (!confirm("本当に削除してもよろしいですか？")) return;
    await service.destroy(Number(this.id));
    this.goListPage();
    await this.$store.dispatch("getStatusProject");
    await this.$store.dispatch("setProjectEstimateExpenseSummary");
  }

  async createCsv() {
    const url = await service.csvDownload(Number(this.id));
    window.open(url);
  }

  async calculateTotal() {
    this.estimate = await service.calculateTotal(this.estimate);
    this.reloadCheckboxOfEstimateRow();
  }

  async calculateInvoice(profitRate: number) {
    if (this.estimateRowSelected.size === 0) {
      alert("対象品目をチェックしてください。");
      return;
    }
    if (!confirm("発注額を上書きします。本当に実行してもよろしいですか？")) {
      return;
    }
    this.estimate = await service.calculateInvoice(
      this.estimate,
      profitRate,
      service.getIdsSelected(this.estimate, this.estimateRowSelected),
      this.estimatedToOrderNumberRound,
      this.estimatedToOrderTypeRound
    );
  }

  private editing = false;

  get childListClassName() {
    return {
      expanded: this.editing
    };
  }

  dragstart() {
    this.editing = true;
  }

  dragend() {
    this.editing = false;
    this.calculateTotal();
  }

  isRouteActualResult() {
    return this.$route.name === "order-estimate-actual";
  }

  protected async created() {
    if (this.$route) {
      this.currentRoute = this.$route.name || "";
    }
    await this.initExpenseCategories();
    await this.edit(Number(this.id));
    await this.initUnitList();
    await this.getServiceTaskDefaults();
  }

  private async edit(id: number) {
    this.estimate = await service.find(id);
    if (
      this.estimate.status != Status.Success &&
      this.$route.name == "order-estimate-actual"
    ) {
      this.$router.push({
        name: "order-estimates"
      });
    }
    if (!this.estimate.projectId) {
      this.estimate.projectId = this.projectId;
      this.estimate.projectName = this.$store.state.project.name;
      if (
        this.$store.state.project.contractDate &&
        this.$store.state.project.contractDate !== "0000-00-00"
      ) {
        this.estimate.dateOfContract = this.$store.state.project.contractDate;
      }
    }
    this.estimate.categoryDiscountIds = this.categoryDiscountIds;
    this.disableDestroy = this.isDisableDestroy();
    this.contractDateInit = this.estimate.dateOfContract;
    this.requiredContractDate = this.isRequiredContractDate();
    applyDefaultEstimatePaymentMethod(this.estimate);
  }

  private async initUnitList() {
    this.unitOptions = [
      { text: "", value: "" },
      ...(await unitApi.findAll()).map(UnitOption)
    ];
  }

  async initExpenseCategories() {
    this.expenseCategories = [
      { id: "", name: "", important: false },
      ...(await getExpenseCategories())
    ];
  }

  async calculateFromProfitRate(profitRate: number) {
    if (this.estimateRowSelected.size === 0) {
      alert("対象品目をチェックしてください。");
      return;
    }
    if (!confirm("見積額を上書きします。本当に実行してもよろしいですか？")) {
      return;
    }

    // TODO: asしなくても通るように型定義したい
    this.estimate = estimateRoundedFromProfitRate(
      this.estimate,
      profitRate,
      service.getIdsSelected(this.estimate, this.estimateRowSelected),
      this.orderToEstimatedNumberRound,
      this.orderToEstimatedTypeRound
    ) as Estimate;
    this.estimate = await service.calculateTotal(this.estimate);
  }

  /**
   * 既存の項目からテンプレートを作る
   */
  async saveTemplate(
    templateName: string,
    { resolve, reject }: { resolve: () => void; reject: () => void }
  ) {
    let items: EstimateItemModel[] = [];
    items.push(...this.estimate.items);
    this.estimate.children.forEach(child => items.push(...child.items));
    try {
      await this.$store.dispatch("estimateTemplate/save", {
        title: templateName,
        items: items
      });
      resolve();
    } catch (error) {
      reject();
    }
  }

  /**
   * テンプレートを使う
   */
  useTemplate(template: EstimateTemplate): void {
    const items = template.items.map(templateItemToItem);
    items.forEach(item => {
      this.estimate.items.push(item);
    });
    this.calculateTotal();
  }

  addTextToMention(text: string) {
    if (this.estimate.mention) {
      this.estimate.mention += "\n";
    }
    this.estimate.mention += text;
    if (text.length > 0 && this.estimate.mention.length > 100) {
      this.estimate.mention = this.estimate.mention.slice(0, 100);
    }
    this.textTemplateModalOpen = false;
  }

  @Watch("estimate", { immediate: true })
  loadExpenseCategory() {
    this.expenseCategoriesSelected = calculateExpenseCategory(
      this.estimate,
      this.expenseCategoryOptions,
      this.categoryDiscountIds
    );
  }

  handleChangeDateOfIssue(value: string) {
    this.estimate.dateOfIssue = value;
    this.estimate.taskDefaults.forEach(item => {
      item.value = moment(value, "YYYY-MM-DD", true)
        .clone()
        .add(item.key.value, "days")
        .format("YYYY-MM-DD");
    });
  }

  deleteRowIdInvalid(item: EstimateItemModel) {
    if (
      item.items.length > 0 ||
      this.categoryDiscountIds.includes(item.expenseCategoryId)
    ) {
      if (this.estimateRowSelected.has(item.id.toString())) {
        this.estimateRowSelected.delete(item.id.toString());
      }
      item.items.forEach(it => this.deleteRowIdInvalid(it));
    }
  }

  deleteIdInvalidInEstimateRowSelected() {
    this.estimate.items.forEach(item => this.deleteRowIdInvalid(item));
    this.estimate.children.forEach(child =>
      child.items.forEach(item => this.deleteRowIdInvalid(item))
    );
  }

  reloadCheckboxOfEstimateRow() {
    // delete the parent row id if there is a child row id in the set
    this.deleteIdInvalidInEstimateRowSelected();

    // Recreate the set to trigger reactivity
    this.estimateRowSelected = new Set(Array.from(this.estimateRowSelected));

    // reload checkbox all row
    this.reloadCheckboxAll();
  }

  convertToNewEstimateRowId(items: EstimateItemModel[]) {
    const updateEstimateRowSelected = (items: EstimateItemModel[]) => {
      items.forEach(item => {
        if (this.estimateRowSelected.has(item.rowUuid.toString())) {
          this.estimateRowSelected.delete(item.rowUuid.toString());
          this.estimateRowSelected.add(item.id.toString());
        }

        if (item.items && item.items.length > 0) {
          updateEstimateRowSelected(item.items);
        }
      });
    };
    updateEstimateRowSelected(items);
  }

  mappingNewEstimateRowId() {
    if (this.estimateRowSelected.size > 0) {
      this.convertToNewEstimateRowId(this.estimate.items);
      this.estimate.children.forEach(child =>
        this.convertToNewEstimateRowId(child.items)
      );
      this.reloadCheckboxOfEstimateRow();
    }
  }

  projectTaskDefaultDate = "";
  private async getServiceTaskDefaults() {
    const serviceTaskDefaults = await getServiceTaskDefaults();
    serviceTaskDefaults.forEach((item: ServiceTaskDefault) => {
      if (
        item.code == "Estimate task default" &&
        !this.estimate.taskDefaults.length
      ) {
        this.estimate.taskDefaults.push({
          key: {
            id: item.id,
            name: item.name
          },
          value: item.value
        } as ProjectTaskDefault);
      }
    });
  }

  reloadCheckboxAll() {
    let numberItems = this.countTotalItems(this.estimate.items);
    this.estimate.children.forEach(child => {
      numberItems += this.countTotalItems(child.items);
    });
    if (numberItems === 0) {
      this.isCheckAllEstimateRow = false;
      return;
    }
    let countItemsSelected = service.getIdsSelected(
      this.estimate,
      this.estimateRowSelected
    ).size;
    this.isCheckAllEstimateRow = countItemsSelected === numberItems;
  }

  countTotalItems(items: EstimateItemModel[]): number {
    let result = 0;
    result += items.filter(
      item => !this.categoryDiscountIds.includes(item.expenseCategoryId)
    ).length;
    items.forEach(item => {
      if (item.items.length > 0) {
        result += this.countTotalItems(item.items);
      }
    });
    return result;
  }

  isDisableDestroy(): boolean {
    return (
      this.estimate.status === EstimateStatus.QuotedNew ||
      this.estimate.status === EstimateStatus.Success
    );
  }

  changeEstimateStatus() {
    this.requiredContractDate = this.isRequiredContractDate();
  }

  isRequiredContractDate(): boolean {
    if (this.contractDateInit) {
      return true;
    }
    return this.estimate.status === EstimateStatus.Success;
  }

  get lossTotal(): string {
    let totalPrice: number = 0;
    let loss: number = 0;
    this.estimate.items.forEach(item => {
      totalPrice += item.totalPrice;
      loss += item.loss;
    });

    this.estimate.children.forEach(child => {
      child.items.forEach(item => {
        totalPrice += item.totalPrice;
        loss += item.loss;
      });
    });

    return (totalPrice - loss).toLocaleString();
  }

  get templateProfitRate() {
    return {
      profitRate: new Decimal(this.estimate.profitRate).div(100).toNumber(),
      lossRate: new Decimal(this.estimate.lossRate).div(100).toNumber()
    };
  }

  isNegative(value: number): boolean {
    return value < 0;
  }

  upLevel(
    oldParent: EstimateItemModel | null,
    newParent: Estimate | null,
    item: EstimateItemModel | null
  ) {
    if (newParent === null || oldParent === null || item === null) {
      return;
    }

    oldParent.items.splice(oldParent.items.indexOf(item), 1);
    newParent.items.splice(newParent.items.indexOf(oldParent) + 1, 0, item);
    this.calculateTotal();
  }

  downLevel(
    oldParent: EstimateItemModel | null,
    newParent: Estimate | null,
    item: EstimateItemModel | null
  ) {
    if (newParent === null || oldParent === null || item === null) {
      return;
    }

    oldParent.items.splice(oldParent.items.indexOf(item), 1);
    newParent.items.splice(newParent.items.length, 0, item);
    this.calculateTotal();
  }

  resetIndex() {
    this.currentIndex.clear();
    this.currentIndex.add(0);
  }

  getNextIndex(): number {
    const firstElement = this.currentIndex.values().next().value;
    this.currentIndex.clear();
    this.currentIndex.add(firstElement + 1);
    return firstElement;
  }

  isLastRow(item: EstimateItemModel, estimate: Estimate) {
    let lastItem = estimate.items[estimate.items.length - 1];

    while (lastItem.items && lastItem.items.length > 0) {
      lastItem = lastItem.items[lastItem.items.length - 1];
    }

    return item === lastItem;
  }

  getEstimateItemProp(
    item: EstimateItemModel,
    level: number,
    index: number
  ): EstimateItemProp {
    const isDiscountRow = this.categoryDiscountIds.includes(
      item.expenseCategoryId
    );
    const isFirstItemInLayer = index === 0;

    return {
      item: item,
      unitOptions: this.unitOptions,
      expenseCategoryOptions: this.expenseCategoryOptions,
      level: level,
      isShowNoteColumn: this.isShowNoteColumn,
      styleGridColumn: this.styleGridColumn,
      estimateRowSelected: this.estimateRowSelected,
      profitRateOfEstimate: this.estimate.profitRate,
      isDiscountRow: isDiscountRow,
      isFirstItemInLayer: isFirstItemInLayer,
      index: this.getNextIndex(),
      isActualResult: this.isRouteActualResult()
    };
  }

  async destroyed() {
    if (
      this.$route.name !== "order-estimate-purchase-actual" &&
      this.currentRoute === "order-estimate-actual"
    ) {
      await estimateApi.updateActualResult(this.projectId, +this.id);
    }
  }

  get disableDragIfActualResult() {
    return {
      disabled: this.isRouteActualResult(),
      preventOnFilter: false,
      filter: "input"
    };
  }

  /**
   * Determines if the right button should be disabled for the current item
   * based on its level and the state of the previous item.
   */
  private shouldDisableButton(currentItem: any, previousItem: any): boolean {
    return (
      currentItem.level === ESTIMATE_ITEM_LEVEL.CHILD &&
      previousItem.level === ESTIMATE_ITEM_LEVEL.CHILD &&
      !previousItem.isEditable
    );
  }

  getAllEstimateRows(items: EstimateItemModel[]): EstimateItemModel[] {
    let result: EstimateItemModel[] = [];
    for (const item of items) {
      result.push(item);
      if (item.items && item.items.length > 0) {
        result = result.concat(this.getAllEstimateRows(item.items));
      }
    }
    return result;
  }
}

function templateItemToItem(item: EstimateTemplateItem): EstimateItemModel {
  return {
    ...item,
    id: uuid(),
    rowUuid: "",
    totalPrice: 0,
    loss: 0,
    items: (item.items || []).map(n => templateItemToItem(n)),
    purchased: false,
    purchasedRow: false,
    vendorName: ""
  };
}
